import React from 'react';
import { Bell, Search, ChevronDown, Menu, User, LogOut } from 'lucide-react';
import useGlobale from './global';
import { useNavigate } from 'react-router-dom';

const Header = ({ toggleSidebar, isSidebarOpen }) => {
  const [isProfileOpen, setIsProfileOpen] = React.useState(false);
  const { logout } = useGlobale();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="bg-white border-b border-gray-200 relative z-50">
      <div className="flex h-16 items-center justify-between px-4 lg:px-6">
        <div className="flex items-center gap-4">
          <button
            onClick={toggleSidebar}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Menu className="h-6 w-6 text-gray-600" />
          </button>

          <div className="relative hidden md:block">
            <input
              type="text"
              placeholder="Rechercher..."
              className="w-96 h-10 pl-10 pr-4 rounded-xl bg-gray-50 border-0 
              focus:ring-2 focus:ring-emerald-500 text-sm"
            />
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
          </div>
        </div>

        <div className="flex items-center gap-4">
          <button className="relative p-2">
            <Bell className="h-6 w-6 text-gray-600" />
            <span className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-red-500"></span>
          </button>

          <div className="relative">
            <button 
              onClick={() => setIsProfileOpen(!isProfileOpen)}
              className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100"
            >
              <div className="h-8 w-8 rounded-lg bg-emerald-500 flex items-center justify-center">
                <User className="h-5 w-5 text-white" />
              </div>
              <ChevronDown className="h-5 w-5 text-gray-500" />
            </button>

            {isProfileOpen && (
              <div className="absolute right-0 mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-100 z-50">
                <div className="p-2">
                  <button 
                    onClick={handleLogout}
                    className="w-full px-3 py-2 text-left text-sm text-red-600 
                    hover:bg-red-50 rounded-md transition-colors flex items-center gap-2"
                  >
                    <LogOut className="h-4 w-4" />
                    Déconnexion
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;